export default __webpack_public_path__ + "static/media/ranger_color.efe5e7b0.png";